import { TableContainer, Table, TableHead, TableCell, TableRow, Typography, TableBody, Paper } from "@mui/material";
import { useState } from "react";
import { Switch } from 'antd';
import "./ClassificationTable.css";

const options = {
    AVERAGE: "average",
    TOTAL: "total"
};

const ClassificationTable = ({ name, data, textColor, backgroundColor }) => {
    const [selectedOption, setSelectedOption] = useState(options.AVERAGE);

    const changeOption = () => {
        if (selectedOption === options.AVERAGE) {
            setSelectedOption(options.TOTAL);
        } else {
            setSelectedOption(options.AVERAGE);
        }
    }

    return (
        <Paper elevation={3} style={{ backgroundColor: backgroundColor, margin: "0.5rem", width: "fit-content", maxWidth: "27rem", maxHeight: "fit-content" }}>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Typography variant="h6" component="div" color={textColor}>
                                    {name}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Switch checkedChildren={options.TOTAL} unCheckedChildren={options.AVERAGE} onClick={changeOption} />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((item, index) => {
                            return (
                                <TableRow key={item.label}>
                                    <TableCell color={textColor} className="table-cell" style={{ display: "flex" }}>
                                        <Typography>
                                            # {index + 1} {item.label}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                        <Typography>
                                            {selectedOption === options.AVERAGE ? item.average : item.total}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

        </Paper>
    );
}

export default ClassificationTable;